/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Monthly_PlanInputs */

const en_monthly_plan = /** @type {(inputs: Monthly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly`)
};

const ar_monthly_plan = /** @type {(inputs: Monthly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شهريًا`)
};

const de_monthly_plan = /** @type {(inputs: Monthly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatlich`)
};

const es_monthly_plan = /** @type {(inputs: Monthly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensual`)
};

const fr_monthly_plan = /** @type {(inputs: Monthly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensuel`)
};

const it_monthly_plan = /** @type {(inputs: Monthly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensile`)
};

const ja_monthly_plan = /** @type {(inputs: Monthly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月間`)
};

const ko_monthly_plan = /** @type {(inputs: Monthly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`월간`)
};

const pt_br_monthly_plan = /** @type {(inputs: Monthly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensal`)
};

const ru_monthly_plan = /** @type {(inputs: Monthly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Месяц`)
};

const th_monthly_plan = /** @type {(inputs: Monthly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายเดือน`)
};

const tr_monthly_plan = /** @type {(inputs: Monthly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aylık`)
};

const zh_cn_monthly_plan = /** @type {(inputs: Monthly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连续包月`)
};

const zh_tw_monthly_plan = /** @type {(inputs: Monthly_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月訂閱`)
};

/**
* | output |
* | --- |
* | "Monthly" |
*
* @param {Monthly_PlanInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const monthly_plan = /** @type {((inputs?: Monthly_PlanInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Monthly_PlanInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_monthly_plan(inputs)
	if (locale === "ar") return ar_monthly_plan(inputs)
	if (locale === "de") return de_monthly_plan(inputs)
	if (locale === "es") return es_monthly_plan(inputs)
	if (locale === "fr") return fr_monthly_plan(inputs)
	if (locale === "it") return it_monthly_plan(inputs)
	if (locale === "ja") return ja_monthly_plan(inputs)
	if (locale === "ko") return ko_monthly_plan(inputs)
	if (locale === "pt_br") return pt_br_monthly_plan(inputs)
	if (locale === "ru") return ru_monthly_plan(inputs)
	if (locale === "th") return th_monthly_plan(inputs)
	if (locale === "tr") return tr_monthly_plan(inputs)
	if (locale === "zh_cn") return zh_cn_monthly_plan(inputs)
	return zh_tw_monthly_plan(inputs)
});